import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { FaXmark } from "react-icons/fa6";
// import "./ModalPopup.css";

const ModalPopup = ({
  isOpen,
  onClose,
  children,
  closeOnOverlayClick = true,
}) => {
  // Close modal when pressing Escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape" && isOpen) {
        onClose();
      }
    };

    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  // Clone children and pass close function as prop
  const childrenWithClose = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { closeModal: onClose });
    }
    return child;
  });

  return (
    <div
      className="modal-overlay"
      onClick={closeOnOverlayClick ? onClose : null}
    >
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close-btn" onClick={onClose}>
          <FaXmark />
        </button>
        {childrenWithClose}
      </div>
    </div>
  );
};

export default ModalPopup;
